module.exports = __webpack_public_path__ + "./assets/outline-icons__ef60a4f6c25ef7f39f2d25a748dbecfe.woff";